import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { SetCurrentRoute, StoreNavigationSession } from "./navigation.actions";
import { map } from "rxjs/operators";

@Injectable()
export class NavigationStateEffects {
  constructor(private actions$: Actions) {}

  public setCurrentRouteEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetCurrentRoute),
      map(() => {
        return StoreNavigationSession();
      })
    )
  );
}
